export default "__VITE_ASSET__WCQlC7GAMhg6nCwnx5Q_$A__"